module.exports = __webpack_public_path__ + "img/837c403d240268bb8383366b4896efe6.png";